import { useParams } from "react-router-dom";
import { useMyProfile } from "@/entities/user";

/**
 * The store the Studio session should be scoped to.
 *
 * Prefers the `:storeId` route param (present on `/store/:storeId/templates`).
 * The editor and preview routes are not store-scoped, so those fall back to
 * the profile's default store — which is exactly what TemplateEditorPage does
 * today, so this is behaviour-preserving. For a multi-store vendor the
 * fallback can resolve to the wrong store; carrying storeId on those routes is
 * tracked as a follow-up.
 */
export function useStudioStoreId(): string | undefined {
  const { storeId: routeStoreId } = useParams<{ storeId?: string }>();
  const { data: profile } = useMyProfile();
  const profileStoreId = (
    profile as { data?: { store?: { id?: string } } } | undefined
  )?.data?.store?.id;
  return routeStoreId ?? profileStoreId;
}
